module.exports = __webpack_public_path__ + "img/logo_fullName_black.38b3cbf4.svg";